// Components
// Types
import type { NavTabProps } from '@/components/composite/NavTabs';
import NavTabs from '@/components/composite/NavTabs';

export type NavTabsButtonsTabType = Pick<NavTabProps, 'name' | 'icon'> & {
    id: string;
};

type NavTabsButtonsProps = {
    tabs: NavTabsButtonsTabType[];
    activeTabId: NavTabsButtonsTabType['id'];
    setActiveTabId: (id: NavTabsButtonsTabType['id']) => void;
};

const NavTabsButtons = ({ tabs, activeTabId, setActiveTabId }: NavTabsButtonsProps) => (
    <NavTabs>
        {tabs.map((tab) => (
            <NavTabs.NavTab
                {...tab}
                isActive={tab.id === activeTabId}
                onClick={() => {
                    setActiveTabId(tab.id);
                }}
                key={tab.id}
            />
        ))}
    </NavTabs>
);

export default NavTabsButtons;
